import { action, computed, observable, store } from '~/common/mobx.decorator'
import { notifyStore } from '~/stores'
import { CREDENTIALS_STATUS } from '~/common/constants'
import { createWorkerCredentials, getWorkerCredentials, markCredentialAsSigned } from '~/features/care-profile/care-profile.service'
import { last } from 'lodash'

@store()
class CredentialsStore {
	@observable workerCredentials = []

	@observable credentialsCreating = false

	@observable credentialsUpdating = false
	@observable credentialsCurrentId = ''

	@observable esignUrl = ''

	@computed
	get pendingCredentialsCount() {
		return this.workerCredentials?.filter((item) => item.status === CREDENTIALS_STATUS.pending)?.length
	}
	@action
	setCredentialsCurrentId = (flag) => {
		this.credentialsCurrentId = flag
	}
	@action
	setCredentialsUpdating = (flag) => {
		this.credentialsUpdating = flag
	}

	@action
	setEsignUrl = (value) => {
		this.esignUrl = value
	}

	@computed
	get credentials() {
		return (
			this.workerCredentials?.map((item) => {
				const lastestSignedDoc = last(item.files)
				return {
					...item,
					files: item.credential?.default
						? lastestSignedDoc
							? [{ ...lastestSignedDoc.file, parent: lastestSignedDoc.id }]
							: []
						: item.files?.map((file) => ({ ...file.file, parentId: file.id })),
				}
			}) ?? []
		)
	}

	@action
	fetchWorkerCredentials = async () => {
		this.workerCredentials = await getWorkerCredentials()
	}

	@action
	handleSubmitCredentials = async ({ location, ...data }) => {
		try {
			const credentials = { ...data, city: location.city, state: location.state }
			await createWorkerCredentials(credentials)
			await this.fetchWorkerCredentials()
			this.setCredentialsCreating(false)
		} catch (error) {
			notifyStore.error(error?.message)
		}
	}

	@action
	setCredentialsCreating = async (flag) => {
		this.credentialsCreating = flag
	}
	@action
	handleRemoveClick = async (flag) => {
		return null
	}

	@action
	markCredentialAsSignedFn = async (id) => {
		const response = await markCredentialAsSigned(id)
		return response
	}
}

export const credentialsStore = new CredentialsStore()
